import moment from 'moment';
import { helpers } from '../Helpers';

export class dateHelper {
    today = (format = helpers.constant.formatDate) => {
        return moment().format(format);
    };
}